import React from 'react';
import QuestionMarkCloud from 'assets/question-mark-cloud';
import useTranslation from 'hooks/use-translation';
import { CenterItems, DutchiePayHeader, DutchiePayTextBody, IconContainer } from 'src/payments/components';
import { PBB_NAME } from 'src/payments/constants';

export function AlreadySignedUp(): JSX.Element {
  const { t } = useTranslation();
  return (
    <CenterItems>
      <IconContainer>
        <QuestionMarkCloud />
      </IconContainer>
      <DutchiePayHeader>{t(`payByBank.alreadyCreated`, 'Pay by Bank account already created!')}</DutchiePayHeader>
      <DutchiePayTextBody>Looks like you are already signed up for {PBB_NAME}.</DutchiePayTextBody>
    </CenterItems>
  );
}
